import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../store';
import * as propertySelectors from '../modules/property/selectors';
import { Path } from '../constants/path';
import { isContractorOnly } from '../modules/invitation';

interface Props {
  children: React.ReactNode;
}

export const AccountStepGuard: React.FC<Props> = ({ children }) => {
  const property = useSelector((state: AppState) => propertySelectors.getProperty(state));
  if (isContractorOnly(property.applicantType)) {
    return <Redirect to={Path.application.url} />;
  }
  return <>{children}</>;
};
